import * as React from 'react'
import { FC } from 'react'
import { graphql } from 'gatsby'
import SearchPage from '../../components/SearchPage/SearchPage'
import Layout from '../../components/Layout/Layout'
import { ISearchItem } from '../../components/SearchPage/SearchPage.types'
import { IProjectExamplesPageProps } from './ProjectExamplesPage.types'

const ProjectExamplesPage: FC<IProjectExamplesPageProps> = ({ data, pageContext }) => (
  <Layout title={'Project Examples'} showScrollToTop>
    <ProjectExamplesPageTemplate data={data} pageContext={pageContext} />
  </Layout>
)

const MarkdownToString = (str: string | undefined) => (str ? str.replaceAll('  <br/>', '') : undefined)

const filter = (articles: ISearchItem[], lowerQuery: string) =>
  articles.filter(
    (article) =>
      article.frontmatter.title?.toLowerCase().includes(lowerQuery) ||
      article.frontmatter.introductionBlock?.title?.toLowerCase().includes(lowerQuery) ||
      article.frontmatter.introductionBlock?.paragraph?.toLowerCase().includes(lowerQuery) ||
      article.frontmatter.introductionBlock?.content?.toLowerCase().includes(lowerQuery) ||
      article.frontmatter.whatWeDidBlock?.title?.toLowerCase().includes(lowerQuery) ||
      article.frontmatter.whatWeDidBlock?.actions?.some(({ title }) => MarkdownToString(title)?.toLowerCase().includes(lowerQuery)) ||
      article.frontmatter.solutionBlock?.title?.toLowerCase().includes(lowerQuery) ||
      article.frontmatter.solutionBlock?.content?.toLowerCase().includes(lowerQuery) ||
      article.frontmatter.solutionBlock?.solutionTiles?.some(
        ({ title, content }) =>
          MarkdownToString(title)?.toLowerCase().includes(lowerQuery) || MarkdownToString(content)?.toLowerCase().includes(lowerQuery)
      ) ||
      article.frontmatter.technologyBlock?.title?.toLowerCase().includes(lowerQuery) ||
      article.frontmatter.benefitsBlock?.title?.toLowerCase().includes(lowerQuery) ||
      article.frontmatter.benefitsBlock?.benefitsList?.some(({ item }) => MarkdownToString(item)?.toLowerCase().includes(lowerQuery)) ||
      article.frontmatter.benefitsBlock?.statsTiles?.some(
        ({ number, text }) =>
          MarkdownToString(number)?.toLowerCase().includes(lowerQuery) || MarkdownToString(text)?.toLowerCase().includes(lowerQuery)
      ) ||
      article.frontmatter.resultBlock?.title?.toLowerCase().includes(lowerQuery) ||
      article.frontmatter.resultBlock?.content?.toLowerCase().includes(lowerQuery) ||
      article.frontmatter.tags?.filter((tag) => MarkdownToString(tag)?.toLowerCase().includes(lowerQuery)).length
  ) ?? []

export const ProjectExamplesPageTemplate: FC<IProjectExamplesPageProps> = ({ data, pageContext }) => (
  <SearchPage data={data} pageContext={pageContext} collectionName={'project-examples'} root={'project-examples'} filter={filter} />
)

export const query = graphql`
  query ProjectTemplatePage($tag: String) {
    markdownRemark(frontmatter: { templateKey: { eq: "ProjectExamples" } }) {
      frontmatter {
        title
        backgroundImage {
          publicURL
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        defaultTileImage {
          publicURL
          childImageSharp {
            fluid(maxWidth: 500, cropFocus: CENTER) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }

    items: allMarkdownRemark(
      filter: { fields: { slug: { regex: "^/project-examples/" } }, frontmatter: { tags: { eq: $tag } } }
      sort: { order: DESC, fields: frontmatter___date }
    ) {
      nodes {
        fields {
          slug
        }
        frontmatter {
          title
          tags
          previewImage {
            publicURL
            childImageSharp {
              fluid(maxWidth: 500, cropFocus: CENTER) {
                base64
                aspectRatio
                src
                srcSet
                sizes
              }
            }
          }
          introductionBlock {
            title
            paragraph
            content
          }
          whatWeDidBlock {
            title
            actions {
              title
            }
          }
          solutionBlock {
            title
            content
            solutionTiles {
              title
              content
            }
          }
          technologyBlock {
            title
          }
          benefitsBlock {
            title
            benefitsList {
              item
            }
            statsTiles {
              item {
                number
                text
              }
            }
          }
          resultBlock {
            title
            content
          }
        }
      }
    }
  }
`

export default ProjectExamplesPage
